import type { State } from './types.tsx';

const addIssueLinkSuggestion =
	(issueKey: string) =>
	({ setState, getState }: { setState: (arg1: State) => void; getState: () => State }) => {
		const state = getState();
		if (state.issueLinkSuggestions.has(issueKey)) {
			return;
		}
		setState({
			...state,
			issueLinkSuggestions: new Set([...state.issueLinkSuggestions, issueKey]),
		});
	};

export const actions = {
	addIssueLinkSuggestion,
} as const;
